import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "overflow-x-auto rounded-2xl border border-slate-200" }
const _hoisted_2 = { class: "users-table min-w-[860px]" }
const _hoisted_3 = { class: "h-12" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  colspan: "6",
  class: "px-4 py-12 text-center text-sm text-slate-500"
}
const _hoisted_7 = { class: "date rounded-r-xl px-4 py-3 text-sm font-semibold text-slate-800" }
const _hoisted_8 = {
  class: "date px-4 py-3 text-sm text-slate-600",
  dir: "ltr"
}
const _hoisted_9 = { class: "date px-4 py-3 text-sm font-semibold text-slate-800" }
const _hoisted_10 = { class: "relative amount px-2 py-2" }
const _hoisted_11 = { class: "relative amount px-2 py-2" }
const _hoisted_12 = { class: "relative amount rounded-l-xl px-2 py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (header, index) => {
            return (_openBlock(), _createElementBlock("th", {
              class: "head",
              key: index
            }, _toDisplayString(header), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", _hoisted_4, [
        (!_ctx.users.length)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
              _createElementVNode("td", _hoisted_6, [
                _createVNode(_component_v_icon, {
                  size: "28",
                  class: "mb-2 text-slate-400"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-account-search-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "block" }, "کاربری با این مشخصات پیدا نشد.", -1))
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: _normalizeClass(["row", index % 2 === 0 ? 'bg-slate-50' : 'bg-white']),
            key: user.id
          }, [
            _createElementVNode("td", _hoisted_7, _toDisplayString(user.name || '—'), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.formatPhone(user.email)), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.FormatPersianAmount(user.wallet || '0')), 1),
            _createElementVNode("td", _hoisted_10, [
              _createVNode(_component_custom_button, {
                onClick: ($event: any) => (_ctx.showUserTransactions(user.id)),
                type: "button",
                text: "تراکنش ها"
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("td", _hoisted_11, [
              _createVNode(_component_custom_button, {
                onClick: ($event: any) => (_ctx.sendUserNotification(user.id)),
                type: "button",
                text: "ارسال پیام"
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("td", _hoisted_12, [
              _createVNode(_component_custom_button, {
                onClick: ($event: any) => (_ctx.handleUserOption(user.id, 'profile')),
                type: "button",
                text: "مشخصات"
              }, null, 8, ["onClick"])
            ])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}